import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const AddResidentNoteRequestDtoSchema = z.object({
  id: z.number(),
  noteText: z.string(),
});

const AddResidentNoteResponseDtoSchema = z.object({
  id: z.number(),
  noteText: z.string(),
  creationDate: z.coerce.date(),
  takenById: z.number(),
});

export type AddResidentNoteRequestDto = z.infer<
  typeof AddResidentNoteRequestDtoSchema
>;
export type AddResidentNoteResponseDto = z.infer<
  typeof AddResidentNoteResponseDtoSchema
>;

export const addResidentNote = (
  dto: AddResidentNoteRequestDto,
  config?: AxiosRequestConfig<AddResidentNoteRequestDto>
) => {
  const { id, ...data } = AddResidentNoteRequestDtoSchema.parse(dto);

  return api
    .post(`residents/${id}/notes`, data, config)
    .then(responseContract(AddResidentNoteResponseDtoSchema));
};
